// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KAsu","type":"styles_type__Uqoxs","choices":"styles_choices__2Goxt"};